export const ADMIN_ROLE_PERMISSIONS = ['internal.admin'] as const
export const EXTERNAL_USER_ROLE_PERMISSIONS = ['external.user'] as const
export const INTERNAL_SHARED_ROLE_PERMISSIONS = [
  'internal.admin',
  'internal.comercial',
  'internal.financiero',
  'internal.director',
] as const

export function checkRolePermissions(
  permissions: readonly string[] | null | undefined,
  requiredPermissions?: readonly string[],
) {
  if (!requiredPermissions?.length)
    return true

  const availablePermissions = permissions ?? []
  return requiredPermissions.some(permission =>
    availablePermissions.includes(permission),
  )
}

export function hasAdminAccess(permissions: readonly string[] | null | undefined) {
  return checkRolePermissions(permissions, ADMIN_ROLE_PERMISSIONS)
}

export function hasExternalAccess(permissions: readonly string[] | null | undefined) {
  return (permissions ?? []).some(permission => permission.startsWith('external.'))
}

export function hasInternalSharedAccess(
  permissions: readonly string[] | null | undefined,
) {
  return checkRolePermissions(permissions, INTERNAL_SHARED_ROLE_PERMISSIONS)
}
